export function latestDeliveryForPlatform(
    record: API.MusicDistribution.MusicRelease | undefined,
    platform: string,
): API.MusicDistribution.Delivery | undefined {
    const matches = record?.deliveries?.filter((x) => x.platform === platform)
    if (!matches?.length) {
        return undefined
    }
    return matches.reduce((latest, d) =>
        (d.sent_at || '') > (latest.sent_at || '') ? d : latest
    )
}

/** Original Upload is blocked when the distributor already has (or is ingesting) this release. */
export function originalUploadBlockedStatus(status: string | undefined): 'sent' | 'ingested' | undefined {
    if (status === 'sent' || status === 'ingested') {
        return status
    }
    return undefined
}
